/* eslint-disable react/no-did-mount-set-state */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import KnowledgeCenter from "./KnowledgeCenter";
import Article from "../../pages/Article/Article";
import {twillBase} from '../../config/API';

class KnowledgeCenterQuery extends Component {

    static propTypes = {
        id: PropTypes.number.isRequired,
        markComponentLoadedAs: PropTypes.func.isRequired,
        // eslint-disable-next-line react/forbid-prop-types
        article: PropTypes.object
    };

    static defaultProps = {
        article: {}
    };

    static getKnowledgeCenterItems = async () => fetch(`${twillBase}/api/articles`).then(res => res.json())

    state = {
        knowledge_center_items_api_call_completed: false,
        knowledge_center_items: [],
    };

    async componentDidMount() {
        if (!this.state.knowledge_center_items_api_call_completed) {
            const knowledgeCenterItems = await KnowledgeCenterQuery.getKnowledgeCenterItems();

            if (knowledgeCenterItems.length && !this.state.knowledge_center_items.length) {

                const filteredAndSorted = knowledgeCenterItems
                    .filter((item) => item.type && item.type.toLowerCase().includes('knowledge'))
                    .sort((a, b) => new Date(b.article_date) - new Date(a.article_date));

                console.info(
                    "filteredAndSorted", filteredAndSorted
                );

                this.setState({
                    knowledge_center_items: filteredAndSorted,
                    knowledge_center_items_api_call_completed: true,
                })
            } else {
                this.setState({
                    knowledge_center_items_api_call_completed: true,
                })
            }

        }
    }

    render() {
        if (!this.state.knowledge_center_items_api_call_completed) return (<div className="pageLoader"/>);

        const {id, markComponentLoadedAs, article} = this.props;


        // TODO: Filter by type of "knowledge" on API call?

        markComponentLoadedAs(id, true);

        console.info(
            "this.state.knowledge_center_items", this.state.knowledge_center_items
        );


        if (article && article.permalink) {
            return (<Article id={article.id}
                             // SupportingImage isn't currently used
                             supportingImage={{entity: {fieldMediaImage: article.featured_image}}}
                             title={article.title}
                             subtitle={article.subtitle}
                             keyword={article.tags.map(tag => tag.name.trim())}
                             content={{processed: article.body}}
                             link={{uri: article.secondary_link}}
                             authors={article.authors}
                             date={{value: article.article_date}}
                             overrideVideoTitle={article.list_link_title}
                             knowledgeCenterItems={this.state.knowledge_center_items}/>);
        }

        return (<KnowledgeCenter items={this.state.knowledge_center_items}/>);
    }

}

export default KnowledgeCenterQuery;



// WEBPACK FOOTER //
// ./frontend/components/KnowledgeCenter/KnowledgeCenterQuery.jsx